import { render } from "./ProjectToolNav.vue?vue&type=template&id=0ca9f1c5"
import script from "./ProjectToolNav.vue?vue&type=script&lang=js"
export * from "./ProjectToolNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__